module.exports = __webpack_public_path__ + "img/bksIyengarTeachingYoga.3fa84633.jpg";